import React from 'react'
import Footer from '../../Components/Footer'
import Navbar from '../../Components/Navbar'
import Trans from '../../Components/Trans'

const TranServices = () => {
  return (
    <>
    <Navbar/>
    <Trans/>
    <Footer/>
    </>
  )
}

export default TranServices